import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isString } from 'lodash';
import { Snackbar } from '@mui';
import { popApplicationMessage } from '@actions/messages-actions';

const getNotification = messageData => {
  if (isString(messageData)) {
    return { message: messageData };
  }
  const { action, onActionTouchTap, ...rest } = messageData;
  // Convert v0.19 action/onActionTouchTap to the Snackbar wrapper's action/onActionClick.
  return {
    ...rest,
    ...(action && onActionTouchTap && { action, onActionClick: onActionTouchTap })
  };
};

const InfoSnackbar = () => {
  const dispatch = useDispatch();
  const messages = useSelector(state => state.messages);
  const previousMessages = useRef(messages);

  useEffect(() => {
    const previousLength = previousMessages.current.length;
    if (messages.length > previousLength) {
      messages.slice(0, messages.length - previousLength).forEach(messageData => {
        Snackbar.info({ ...getNotification(messageData), onDismiss: () => dispatch(popApplicationMessage()) });
      });
    }
    previousMessages.current = messages;
  }, [messages, dispatch]);

  return null;
};

export default InfoSnackbar;
